import { defineComponent as _defineComponent } from 'vue'
import { encryptionCustomerBack } from "@/api/php/me";
import ApiNetWork from "@/network/apiNet/apiNet";
import { cheackQuery, ToBack } from "@/uitls/native";
import axios from "axios";
import { Toast } from "vant";
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'Proposal',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const route = useRoute();
const router = useRouter();
// const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;
const primaryColor = '#0D0D0D';
const typeList = ref([
    { id: 1, name: t('me.gxydkn') },
    { id: 2, name: t('me.videohp') },
    { id: 3, name: t('me.mflt') },
    { id: 4, name: t('me.syhm')},
    { id: 5, name: t('me.bstk') },
    { id: 6, name: t('me.mbf') },
    { id: 7, name: t('me.bsts') },
    { id: 8, name: t('me.cpty') },
])
const typeid = ref(1)
const inputtext = ref("")
onMounted(() => {
    cheackQuery(route);
});

const uploaderImg = (file) => {
    let img = file.file;

    let formData = new FormData();
    formData.append("file", img)
    const url = ApiNetWork.uploadGetAddress();

    // ApiNetWork
    axios.post(`${url}app/appFileUpload`, formData).then((response) => {

        if (response.status == 200) {
            console.log("======>", response);
            file.status = 'done';
            file.message = '成功';
            fileList.value = [{
                url: response.data,
                status: 'done',
                message: '成功',
            }]
        }
    });
}
const changeType = (index) => {
    typeid.value = typeList.value[index].id
}

const beforeRead = (file) => {
    const type = file.type
    if (type == 'image/jpeg' || type == 'image/png') {
        return true;
    }
    Toast(t('me.qscjpg'));
    return false;
};

const afterRead = (file) => {
    file.status = 'uploading';
    file.message = t('me.scz');
    uploaderImg(file)
}
const fileList = ref([]);
const tel = ref("");
const btnok = ref(false)
const checkText = () => {
    if (tel.value.length > 0 && inputtext.value.length > 0) {
        //资料都填完了，可以提交
        btnok.value = true;
    }
}
const subok = async () => {
    if (!btnok.value) {
        return
    }
    let text = "";
    typeList.value.forEach((item) => {
        if (item.id == typeid.value) {
            text = item.name
        }
    })
    let img = '';
    if (fileList.value.length > 0) {
        img = fileList.value[0].url
    }
    const res: any = await encryptionCustomerBack({
        class: text,
        content: inputtext.value,
        contact: tel.value,
        img_list: img
    })
    if (res && res.code == 200) {
        Toast.success(t('me.tgcg'))
        router.back()
    }

}
const onOversize = (file) => {
    console.log(file);
    Toast(t('me.wjbncg'));
};


const __returned__ = { t, route, router, primaryColor, typeList, typeid, inputtext, uploaderImg, changeType, beforeRead, afterRead, fileList, tel, btnok, checkText, subok, onOversize, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})